import React, { useEffect, useState } from 'react';
import * as moment from 'moment';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {
    isBuyingPaymentMethod, isSellingPaymentMethod, userComments, reportAbuse, ratings
} from 'redux/actions/customerReviews';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';

import Layout from 'web/components/Layout';
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import Spinner from 'web/components/Spinner';
// import FavoriteIcon from '@material-ui/icons/Favorite';
import Rating from '@material-ui/lab/Rating';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Container, Wrapper, SellerInfo, ActionSection, CustomerReview, ShortingSection, ReviewBox, RatingWrapper } from './customerReviewsStyled'

const CustomerReviews = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const [value, setValue] = React.useState(2);
    const [response, setResponse] = React.useState();

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('/');
    const toggleModal = () => setModal(!modal);
    let title = '';

    const loaderVisible = useSelector(
        (state) => state.appReducer.loaderVisible
    );

    const token = localStorage.getItem('token');
    let userLoginId = localStorage.getItem('userLoginId')

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fetchMyAPI = async (userId, postType) => {
        let userType;
        if (postType === "PostInventory") {
            userType = "SELLER"
        } else {
            userType = "BUYER"
        }
        if (token === null) {
            setModalContent('Please Sign In again.');
            setModalLink('/sign-in');
            toggleModal();
        } else {
            let response = await dispatch(userComments(userType, userId, token));
            if (response.status === "SUCCESS") {
                if (response.payload) {
                    setResponse(response.payload)
                }
            } else {
                if (response.message === "Unauthorized (Invalid token)") {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {
                    setModalContent(response.message);
                    setModalLink('');
                    toggleModal();
                }
            }
        }
    }

    const reportAbuseApi = async (commentId) => {

        let response = await dispatch(reportAbuse(commentId, token));
        if (response.status === "SUCCESS") {
            setModalContent(response.message);
            fetchMyAPI(paramsType.userId, paramsType.postType)
            setModalLink('');
            toggleModal();
        } else {
            if (response.message === "Unauthorized (Invalid token)") {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                setModalLink('');
                toggleModal();
            }
        }
    }

    const [paramsType, setParamsType] = useState({
        userId: '',
        postType: '',
    });

    const [ratingResponse, setRatingResponse] = React.useState();
    const ratingsApi = async (authId) => {

        let data = {
            postAuthId: authId
        }
        let response = await dispatch(ratings(token, data));
        if (response.status === "SUCCESS") {
            if (response.payload) {
                setRatingResponse(response.payload)
            }
        } else {
            if (response.message === "Unauthorized (Invalid token)") {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                setModalLink('');
                toggleModal();
            }

        }
    }

    const [cutomerRating, setCutomerRating] = React.useState();
    useEffect(() => {
        const { location } = props;
        const queryParams = new URLSearchParams(location.search)

        if (!localStorage.getItem('token')) {
            history.push('/sign-in')
            window.location.reload(false);
        } else {
            setParamsType({
                ...paramsType,
                userId: queryParams.get("userId"),
                postType: queryParams.get("postType"),
            })

            fetchMyAPI(queryParams.get("userId"), queryParams.get("postType"))
            ratingsApi(queryParams.get("authId"))
            setCutomerRating(queryParams.get("rating"))
        }
    }, []);

    return (
        <Layout transparentHeader={false} userType="Buyer" topBarViewMobile={"hide"}>
            {loaderVisible && <Spinner />}

            <Container>
                {response && <Wrapper>
                    <SellerInfo>
                        {response.address && <div>
                            <h3>Account Info:</h3>
                            <h4>{response.address.name}</h4>
                            <p>{response.address.line1} {response.address.line2}</p>
                            <p>{response.address.city}&nbsp; {response.address.state}&nbsp; {response.address.zip}</p>
                        </div>
                        }

                        {ratingResponse && <div>
                            <RatingWrapper>
                                <h6 className="">Customer Rating&nbsp;</h6>
                                <Box component="fieldset" mb={3} borderColor="transparent">
                                    <Rating
                                        name="simple-controlled"
                                        value={cutomerRating}
                                        onChange={(event, newValue) => {
                                            setValue(newValue);
                                        }}
                                    />
                                </Box>

                            </RatingWrapper>
                            <h6 className="rateHeading">Service Ratings</h6>

                            <RatingWrapper>
                                <p>On Time Delivery (to day)</p>
                                <Box component="fieldset" mb={3} borderColor="transparent">
                                    <Rating
                                        name="simple-controlled"
                                        value={ratingResponse.totalDelivered}
                                        onChange={(event, newValue) => {
                                            setValue(newValue);
                                        }}
                                    />
                                </Box>

                            </RatingWrapper>
                            <RatingWrapper>
                                <p>Order Cancellations</p>
                                <Box component="fieldset" mb={3} borderColor="transparent">
                                    <Rating
                                        name="simple-controlled"
                                        value={ratingResponse.totalCancelled}
                                        onChange={(event, newValue) => {
                                            setValue(newValue);
                                        }}
                                    />
                                </Box>

                            </RatingWrapper>
                            <RatingWrapper>
                                <p>Claims</p>
                                <Box component="fieldset" mb={3} borderColor="transparent">
                                    <Rating
                                        name="simple-controlled"
                                        value={ratingResponse.totalClaimed}
                                        onChange={(event, newValue) => {
                                            setValue(newValue);
                                        }}
                                    />
                                </Box>

                            </RatingWrapper>
                        </div>}
                    </SellerInfo>
                    {response.comments !== 0 && response.countComments !== 0 && <CustomerReview>
                        <h2>Customer Reviews<span> ({response.countComments})</span></h2>
                        {response.comments.map((item, index) => (<ReviewBox key={index}>
                            <h3>{item.postedByInfo.name}</h3>
                            <div><p>Reviewed <span>{item.title}</span>on {moment(item.createdAt && item.createdAt).format(FORMAT)}</p></div>
                            <p>{item.comment}</p>

                            {userLoginId === item.abuseReportedInfo && item.abuseReportedInfo[0].userId ? <ActionSection><p onClick={() => {
                            }}>Report Abuse</p></ActionSection> :
                                <>
                                    {!item.isReportAbuse ? <ActionSection><span onClick={() => {
                                        reportAbuseApi(item.id)
                                    }}>Report Abuse</span></ActionSection> :
                                        <ActionSection>
                                            <p onClick={() => { }}>Report Abuse</p>
                                        </ActionSection>}
                                </>
                            }

                        </ReviewBox>
                        ))}
                    </CustomerReview>
                    }
                </Wrapper>
                }
            </Container>

            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title={title}
                content={modalContent}
                link={modalLink}
            />

        </Layout>
    );
}
export default CustomerReviews;
